import React from 'react';
import AddProduct from '../AddProduct/AddProduct';




const Admin = () => {

    return (
        <div className="container">
            <AddProduct></AddProduct>
        </div>
    );
};

export default Admin;